import SurveyStudio from '@playground/features/survey-studio/SurveyStudio'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/_superAdmin/survey-studio')({
  component: SurveyStudio,
})
